import { reportsSalesFunnelListOptions, SalesFunnelReport } from '@crm/api'
import { Funnel } from '@crm/components'
import { getColor } from '@crm/components/Charts/utils'
import { useQueryUpdate } from '@shared/hooks'
import { useLocales } from '@shared/locales'

import { useQuery } from '@tanstack/react-query'
import { Card, Col, List, Row, Space } from 'antd'
import { useMemo } from 'react'

import { useStyles } from '../styles'

export const SalesFunnelCard = () => {
  const { t } = useLocales()
  const { params } = useQueryUpdate()

  const { styles } = useStyles()
  const { data, isLoading } = useQuery(
    reportsSalesFunnelListOptions({
      query: params
    })
  )

  const tableData = useMemo(() => {
    if (!data) return
    return data?.map((item: SalesFunnelReport, key: number) => ({
      text: item.name,
      value: item.count,
      color: getColor(key)
    }))
  }, [data])

  return (
    <Card title={t('menu.sales_funnel')} loading={isLoading}>
      <Row gutter={20}>
        <Col span={tableData?.find((i) => (i?.value ?? 0) > 0) ? 12 : 0}>
          {tableData?.find((i) => (i?.value ?? 0) > 0) && (
            <Funnel dataSource={tableData} />
          )}
        </Col>

        <Col flex="auto">
          <List
            dataSource={tableData}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  title={
                    <Space size="small">
                      <div
                        className={styles.listBullet}
                        style={{ background: item?.color }}
                      />
                      {item?.text}
                    </Space>
                  }
                />
                {item?.value}
              </List.Item>
            )}
          />
        </Col>
      </Row>
    </Card>
  )
}
